import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquisortable',
	templateUrl:'./JQUISortablePage.html',
	styles: [],
	styleUrls:['./JQUISortablePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUISortablePage
{
	mdContent_222 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.sortable.JQUISortable;
\`\`\``;
	mdContent_223 = `\`\`\`java
new JQUISortable&lt;&gt;()
\`\`\``;
	mdContent_224 = `\`\`\`java
var list = new JQUISortable<>();
list.addItem("Item A");
list.addItem("Item B");
list.addItem("Item C");
\`\`\``;
}
